import { Axios, AxiosResponse } from "axios";
import { http, ServerType } from "../http";
import { IFeatureCollectionModel,
    IGetAreasResModel,
    IGetLocationsResModel,
    IGetWeevilTrakResModel,
    IGetWeeviltrakStagesResModel,
    IWeevilTrakLoginResModel,
    IWeevilTrakRegisterResModel,
    IWeeviltrakSearchLocationsResModel} from "./responseType";
import { IGetWeevilTrakReqModel,
    IWeevilTrakGetUsersReqModel,
    IWeevilTrakLoginReqModel,
    IWeevilTrakRegisterReqModel,
    IWeevilTrakResetPasswordReqModel,
    IWeevilTrakUpdateUserReqModel} from "./requestType";



const getBoundaries = async (code?: string) => {
    const url = "/api/Lightning/GetBoundaries";
    const res = await http.post<{code?:string},AxiosResponse<IFeatureCollectionModel>>(url,
        {
            code: code
        },
        ServerType.ServerSimulation,
        false,
        null,
        false
    );
    return res;
};


const getWeeviltrakStages = async () => {
    const url = "/api/Weeviltrak/GetWeeviltrakStages";
    const res = await http.get<null,AxiosResponse<IGetWeeviltrakStagesResModel[]>>(url,
        null,
        ServerType.ServerSimulation,
        false
    );
    return res;
};

const getLocations = async (searchText:string) => {
    const url = "/api/Weeviltrak/GetLocations?searchText="+searchText;
    const response = await http.get<null, AxiosResponse<IGetLocationsResModel[]>>(url,
        null,
        ServerType.ServerSimulation
    );
    return response;
};

const searchLocations = async (searchText:string) => {
    const url = "/api/Weeviltrak/SearchLocations?searchText="+searchText;
    const response = await http.get<null, AxiosResponse<IWeeviltrakSearchLocationsResModel[]>>(url,
        null,
        ServerType.ServerSimulation
    );
    return response;
};
const getAreas = async () => {
    const url = "/api/Weeviltrak/GetAreas";
    const res = await http.get<null,AxiosResponse<IGetAreasResModel[]>>(url,
        null,
        ServerType.ServerSimulation,
        false,
    );
    return res;
};

const weevilTrak = async (data:IGetWeevilTrakReqModel) => {
    const url = "/api/WeevilTrak/GetStagePredictionData";
    const res = await http.post<IGetWeevilTrakReqModel,AxiosResponse<IGetWeevilTrakResModel>>(url,
        {
            ...data
        },
        ServerType.ServerSimulation,
        true,
    );
    return res;
};

// for user management
const weevilTrakRegister = async (data:IWeevilTrakRegisterReqModel) => {
    const url = "/api/WeevilTrak/Register";
    const res = await http.post<IWeevilTrakRegisterReqModel,AxiosResponse<IWeevilTrakRegisterResModel>>(url,
        {
            ...data
        },
        ServerType.ServerSimulation,
        true,
    );
    return res;
};
const weevilTrakLogin = async (data:IWeevilTrakLoginReqModel) => {
    const url = "/api/WeevilTrak/Login";
    const res = await http.post<IWeevilTrakLoginReqModel,AxiosResponse<IWeevilTrakLoginResModel>>(url,
        {
            ...data
        },
        ServerType.ServerSimulation,
        true,
    );
    return res;
};

const weevilTrakSendVerificationCode = async (email:string) => {
    const url = "/api/WeevilTrak/SendVerificationCode";
    const res = await http.post<{email: string},AxiosResponse<boolean>>(url,
        {
            email: email
        },
        ServerType.ServerSimulation,
        true,
    );
    return res;
};

const weevilTrakResetPassword = async (data:IWeevilTrakResetPasswordReqModel) => {
    const url = "/api/WeevilTrak/ResetPassword";
    const res = await http.post<IWeevilTrakResetPasswordReqModel,AxiosResponse<string>>(url,
        {
            ...data
        },
        ServerType.ServerSimulation,
        true,
    );
    return res;
};

const weevilTrakGetUsers = async (data:IWeevilTrakGetUsersReqModel) => {
    const url = "/api/WeevilTrak/GetUsers";
    const res = await http.post<IWeevilTrakGetUsersReqModel,AxiosResponse<IWeevilTrakRegisterResModel[]>>(url,
        {
            ...data
        },
        ServerType.ServerSimulation,
        true,
    );
    return res;
};

const weevilTrakUpdateUser = async (data:IWeevilTrakUpdateUserReqModel) => {
    const url = "/api/WeevilTrak/UpdateUser";
    const res = await http.post<IWeevilTrakUpdateUserReqModel,AxiosResponse<string>>(url,
        {
            ...data
        },
        ServerType.ServerSimulation,
        true,
    );
    return res;
};


export {
    getWeeviltrakStages,
    getLocations,
    getAreas,
    weevilTrak,
    searchLocations,
    weevilTrakRegister,
    weevilTrakLogin,
    weevilTrakSendVerificationCode,
    weevilTrakResetPassword,
    weevilTrakGetUsers,
    weevilTrakUpdateUser
};

